// measure-container.js
class MeasureContainer {
      constructor(containerId) {
      this.container = document.getElementById(containerId);

      console.log('dit', this.container);
   
      this.createElements();
      this.addStyles();
      this.addListeners();
    }
  
    createElements() {
      this.hor = document.createElement('div');
      this.ver = document.createElement('div');
      this.coords = document.createElement('div');
  
      this.hor.classList.add('line', 'horizontal');
      this.ver.classList.add('line', 'vertical');
      this.coords.classList.add('coords');
  
      this.container.appendChild(this.hor);
      this.container.appendChild(this.ver);
      this.container.appendChild(this.coords);
    }
  
    addStyles() {
      const style = document.createElement('style');
      style.textContent = `
        .line {
          position: absolute;
          background: #000;
          pointer-events: none;
          z-index: 5000;
        }
        .horizontal {
          height: 1px;
          width: 100%;
        }
        .vertical {
          width: 1px;
          height: 100%;
        }
        .coords {
          position: absolute;
          background: #000;
          color: #fff;
          padding: 2px 6px;
          font-size: 12px;
          border-radius: 3px;
          pointer-events: none;
          white-space: nowrap;
          z-index: 5000;
        }
      `;
      document.head.appendChild(style);
    }
  
    addListeners() {
      this.container.addEventListener('mousemove', (e) => {
        const rect = this.container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
  
        this.hor.style.top = y + 'px';
        this.ver.style.left = x + 'px';
  
        this.coords.textContent = `x: ${x}, y: ${y}`;
        this.coords.style.left = (x + 10) + 'px';
        this.coords.style.top = (y + 10) + 'px';
  
        this.hor.style.display = 'block';
        this.ver.style.display = 'block';
        this.coords.style.display = 'block';
      });
  
      this.container.addEventListener('mouseleave', () => {
        this.hor.style.display = 'none';
        this.ver.style.display = 'none';
        this.coords.style.display = 'none';
      });
    }
  }

window.MeasureContainer = MeasureContainer;

export default MeasureContainer;
  